'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Well = require('../../lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'well': 'Default__well___-PRFz',
  'label': 'Default__label___2_a4i'
};

var DefaultWell = (0, _mergeThemeHoc2.default)(style)(_Well2.default);
DefaultWell.displayName = 'DefaultWell';
exports.default = DefaultWell;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/Well/index.js
// module id = 851
// module chunks = 4 5 8 9 14